import React from 'react'
import Row from '../components/Row'

const SelectedDevices = ({ selectedDevices, onRemove, onSort, sortBy, isSortAsc }) => {

    const headers = [
        {
            key: "name",
            name: "Name",
            width: 3
        },
        {
            key: "os",
            name: "OS",
            width: 2
        },
        {
            key: "osVersion",
            name: "OS Version",
            width: 2
        },
        {
            key: "model",
            name: "Model",
            width: 2
        },
        {
            key: "deviceType",
            name: "Device Type",
            width: 2
        },
        {
            key: 'remove',
            name: '',
            width: 1,
            sortable: false
        }
    ]

    const renderTableHeaders = () => {
        const arrow =  isSortAsc ? <span className="glyphicon glyphicon-triangle-bottom" title="Active" /> : <span className="glyphicon glyphicon-triangle-top" title="Inactive" />

        return headers.map(({ key, name, width, sortable }) => {
            if (sortable === false) {
                return (
                    <th key={key}>
                        <div className={`text-center table-header col-sm-${width}`}>{name}</div>
                    </th>
                )
            }
    
            return (
                <th key={key}  onClick={() => onSort(key)}>
                    <div className={`text-center table-header table-header-clickable col-sm-${width} flex-center`} >
                        {name} {sortBy === key && arrow }
                    </div>
                </th>
            )
        })
      }

    const renderRows = () => {
        if (selectedDevices.length) {
        return selectedDevices.map(({_id, name, os, osVersion, model, deviceType}) => {

            const selectedFields = {
                name,
                os,
                osVersion,
                model,
                deviceType,
                remove: <a className="remove-device-cluster"><span className="glyphicon glyphicon-minus red" /></a>
            }

            return <Row key={_id} data={selectedFields} onClick={() => onRemove(_id)}/>
        })}
        }

        return (
            <table className="table">
                <thead>
                    <tr>{ renderTableHeaders() }</tr>
                </thead>
                <tbody>{ renderRows() }</tbody>
          </table>
        )
       
}

export default SelectedDevices